export type ViewMode = 'nitido' | 'partitura' | 'palco';

export const VIEW_MODE_STORAGE_KEY = 'cifras:view-mode';
export const DEFAULT_VIEW_MODE: ViewMode = 'nitido';

type ChordStyle = {
  color: string;
  fontFamily: 'inter' | 'display';
  fontWeight: number;
  fontSize?: string;
  /** Acorde dentro de uma pill (modo Palco). */
  pill?: { background: string; padding: string; radius: string };
};

export type ViewModeConfig = {
  label: string;
  chord: ChordStyle;
  lyrics: { color: string; fontSize: string; titleSize?: string };
  sectionLabel: 'dot-line' | 'pill' | 'dot-display';
  lineGap: string;
  controls: 'floating-bar' | 'sticky-top' | 'dock';
  setlistPanel: 'left-column' | 'dock-only';
  diagrams: 'strip' | 'right-column';
};

export const VIEW_MODES: Record<ViewMode, ViewModeConfig> = {
  nitido: {
    label: 'Nítido',
    chord: { color: '#5E98FF', fontFamily: 'inter', fontWeight: 700, fontSize: '.82em' },
    lyrics: { color: '#D4D4D4', fontSize: '20px' },
    sectionLabel: 'dot-line',
    lineGap: '6px',
    controls: 'floating-bar',
    setlistPanel: 'left-column',
    diagrams: 'strip',
  },
  partitura: {
    label: 'Partitura',
    chord: { color: '#FFFFFF', fontFamily: 'display', fontWeight: 800 },
    lyrics: { color: '#A8A8A8', fontSize: '20px' },
    sectionLabel: 'pill',
    lineGap: '8px',
    controls: 'sticky-top',
    setlistPanel: 'left-column',
    diagrams: 'right-column',
  },
  palco: {
    label: 'Palco',
    chord: {
      color: '#B4D0FF',
      fontFamily: 'inter',
      fontWeight: 700,
      pill: { background: '#0E1A2E', padding: '1px 7px', radius: '6px' },
    },
    lyrics: { color: '#FFFFFF', fontSize: '20px', titleSize: '52px' },
    sectionLabel: 'dot-display',
    lineGap: '10px',
    controls: 'dock',
    setlistPanel: 'dock-only',
    diagrams: 'strip',
  },
};

export const isViewMode = (value: unknown): value is ViewMode =>
  typeof value === 'string' && value in VIEW_MODES;
